RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CustomerChangeRequest = Marionette.ItemView.extend({
        template: '#adminCompanyCustomerChangeRequestTemplate',
        tagName: 'tr',

        ui: {
            completeBtn: '.x-complete'
        },

        events: {
            'click @ui.completeBtn': 'complete'
        },

        complete: function () {
            const me = this;
            me.model.set({
                completed: true
            });
            me.render();
        }
    });
});
